import { EmptyMarginStart } from '../components/Message/MessageIcon';
import React from 'react';
import styled from 'styled-components';
import { OptionType } from '../graphql/graphql';
import { SimpleOption } from './SimpleOption';
import { QuestionOption } from './QuestionOption';
import { isNilOrEmpty } from '../lib/utils';
import { LinkOption } from './LinkOption';
const Container = styled.div `
  display: flex;
`;
const Options = styled.div `
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 1rem;

  button {
    font-size: 0.8125rem;
    color: black;
  }
`;
export const QuestionOptions = ({ options, isNotLastOption, onOptionClick, isLastMessageCloseEvent, }) => {
    return (React.createElement(Container, null,
        React.createElement(EmptyMarginStart, null),
        React.createElement(Options, null, options.map((option, index) => {
            if ((option === null || option === void 0 ? void 0 : option.optionType) === OptionType.Link) {
                return (React.createElement(LinkOption, { title: option.label, value: option.value, key: index }));
            }
            else if (isNilOrEmpty(option === null || option === void 0 ? void 0 : option.description)) {
                return (React.createElement(SimpleOption, { disabled: isNotLastOption &&
                        (isLastMessageCloseEvent ||
                            option.optionType === undefined ||
                            option.optionType === OptionType.OnetimeReply), onClick: () => onOptionClick === null || onOptionClick === void 0 ? void 0 : onOptionClick(option.value), value: option.value, key: index }));
            }
            return (React.createElement(QuestionOption, { disabled: isNotLastOption &&
                    (isLastMessageCloseEvent ||
                        option.optionType === undefined ||
                        option.optionType === OptionType.OnetimeReply), onClick: () => onOptionClick === null || onOptionClick === void 0 ? void 0 : onOptionClick(option.value), title: option.label, description: option.description, value: option.value, key: index }));
        }))));
};
//# sourceMappingURL=QuestionOptions.js.map